import { Component, input } from '@angular/core';

@Component({
    selector: 'gray-label-wrapper',
    templateUrl: './gray-label-wrapper.component.html',
    standalone: false
})
export class GrayLabelWrapperComponent {
  fieldName = input.required<string>();
  fieldLabel = input.required<string>();
  labelClass = input<string>("bg-gray-200 bg-opacity-40 ism-blue");
  valueClass = input<string>("");

}
